<template>
  <el-dialog
    title="销售订单详情"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="1000px">
    
    <!-- 订单基本信息 -->
    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <span>订单信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <label>订单号：</label>
            <span>{{ orderInfo.orderNo }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>客户类型：</label>
            <el-tag v-if="orderInfo.customerType === 'WALK_IN'" type="info">散客</el-tag>
            <el-tag v-else-if="orderInfo.customerType === 'MEMBER'" type="success">会员</el-tag>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>支付状态：</label>
            <el-tag v-if="orderInfo.paymentStatus === 'PENDING'" type="warning">待支付</el-tag>
            <el-tag v-else-if="orderInfo.paymentStatus === 'PAID'" type="success">已支付</el-tag>
            <el-tag v-else-if="orderInfo.paymentStatus === 'REFUNDED'" type="danger">已退款</el-tag>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="8">
          <div class="info-item">
            <label>客户姓名：</label>
            <span>{{ orderInfo.customerName }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>客户电话：</label>
            <span>{{ orderInfo.customerPhone }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>支付方式：</label>
            <el-tag v-if="orderInfo.paymentMethod === 'CASH'" type="success">现金</el-tag>
            <el-tag v-else-if="orderInfo.paymentMethod === 'WECHAT'" type="success">微信</el-tag>
            <el-tag v-else-if="orderInfo.paymentMethod === 'ALIPAY'" type="primary">支付宝</el-tag>
            <el-tag v-else-if="orderInfo.paymentMethod === 'MEMBER_BALANCE'" type="warning">会员余额</el-tag>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="8">
          <div class="info-item">
            <label>收银员：</label>
            <span>{{ orderInfo.cashierName }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>创建时间：</label>
            <span>{{ orderInfo.createTime }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>备注：</label>
            <span>{{ orderInfo.remark || '无' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    
    <!-- 订单金额信息 -->
    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <span>金额信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="amount-item">
            <label>总金额：</label>
            <span class="amount-value">¥{{ orderInfo.totalAmount }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="amount-item">
            <label>折扣金额：</label>
            <span class="amount-value discount">¥{{ orderInfo.discountAmount }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="amount-item">
            <label>实付金额：</label>
            <span class="amount-value total">¥{{ orderInfo.actualAmount }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    
    <!-- 销售明细 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>销售明细</span>
      </div>
      <el-table
        :data="saleDetails"
        border
        style="width: 100%">
        <el-table-column prop="productName" label="产品名称" width="200"></el-table-column>
        <el-table-column prop="productCode" label="产品编码" width="120"></el-table-column>
        <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="单价" width="100" align="right">
          <template slot-scope="scope">
            ¥{{ scope.row.unitPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="discountAmount" label="折扣" width="100" align="right">
          <template slot-scope="scope">
            ¥{{ scope.row.discountAmount }}
          </template>
        </el-table-column>
        <el-table-column prop="subtotalAmount" label="小计" width="120" align="right">
          <template slot-scope="scope">
            <span class="subtotal-amount">¥{{ scope.row.subtotalAmount }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button type="primary" @click="printOrder">打印订单</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        orderInfo: {},
        saleDetails: []
      }
    },
    methods: {
      init (id) {
        this.visible = true
        this.getOrderInfo(id)
        this.getSaleDetails(id)
      },
      getOrderInfo (id) {
        this.$http({
          url: `saleorder/info/${id}`,
          method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.orderInfo = data.data
          }
        })
      },
      getSaleDetails (orderId) {
        this.$http({
          url: `saledetail/byOrder/${orderId}`,
          method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.saleDetails = data.data || []
          }
        })
      },
      printOrder () {
        this.$message.info('打印功能开发中...')
      }
    }
  }
</script>

<style scoped>
  .info-item {
    margin-bottom: 10px;
  }
  
  .info-item label {
    font-weight: bold;
    color: #606266;
    margin-right: 10px;
  }
  
  .amount-item {
    text-align: center;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;
  }
  
  .amount-item label {
    display: block;
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
  }
  
  .amount-value {
    font-size: 24px;
    font-weight: bold;
    color: #409EFF;
  }
  
  .amount-value.discount {
    color: #67C23A;
  }
  
  .amount-value.total {
    color: #E6A23C;
    font-size: 28px;
  }
  
  .subtotal-amount {
    font-weight: bold;
    color: #409EFF;
  }
</style>








